import { render, staticRenderFns } from "./orgDetail.vue?vue&type=template&id=6624cd77&scoped=true&"
import script from "./orgDetail.vue?vue&type=script&lang=js&"
export * from "./orgDetail.vue?vue&type=script&lang=js&"
import style0 from "./orgDetail.vue?vue&type=style&index=0&id=6624cd77&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6624cd77",
  null
  
)

export default component.exports